import { gql } from '@apollo/client';
import {
  BASE_DATASET,
  DATASET_COLUMN_MAPPING_FRAGMENT,
  DATASET_FRAGMENT,
  DATASET_TABLE_REPRESENTATION_FRAGMENT,
} from 'graphql/secure/fragments/dataset.fragments';
import { SITE_CLUSTER_FRAGMENT } from 'graphql/secure/fragments/site.fragments';

export const GET_DATASET = gql`
  query GetDataset($id: UUID!) {
    dataset(id: $id) {
      ...datasetValues
    }
  }
  ${DATASET_FRAGMENT}
`;

export const GET_DATASET_MAPPED_COLUMNS = gql`
  query GetDatasetTableRepresentation($id: UUID!) {
    dataset(id: $id) {
      id
      mappedColumns {
        ...datasetColumnMappingValues
      }
    }
  }
  ${DATASET_COLUMN_MAPPING_FRAGMENT}
`;

export const GET_DATASET_TABLE_REPRESENTATION = gql`
  query GetDatasetTableRepresentation($id: UUID!) {
    dataset(id: $id) {
      id
      tableRepresentation {
        ...datasetTableRepresentationValues
      }
    }
  }
  ${DATASET_TABLE_REPRESENTATION_FRAGMENT}
`;

export const GET_DATASETS = gql`
  query GetDatasets($filters: DatasetsFilters, $first: Int, $after: String, $before: String) {
    datasets(filters: $filters, first: $first, after: $after, before: $before) {
      edges {
        node {
          ...baseDatasetValues
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_DATASET}
`;

export const GET_DATASET_CLUSTERS = gql`
  query GetDatasetClusters($datasetId: UUID!) {
    datasetClusters(id: $datasetId) {
      ...siteClusterValues
    }
  }
  ${SITE_CLUSTER_FRAGMENT}
`;
